<div class="loading-container">
    <img alt="Loading..." [style]="style" src="assets/loading-logo.svg">
    <p *ngIf="showLabel" class="loading-text" i18n="@@initializeWorkiaPage">Initializing Workia Outlook Add-in...</p>
</div>
